import React from "react";
import { withRouter, NavLink } from "react-router-dom";
import { BoxDanger, BoxSuccess, MnemoCallout, ModalHandler, MSection, SupportoTecnico, Title } from "components/misc";
import { MnemoCardTag, MnemoLoading } from "components/misc";
import { learningService, lessonTrainingService, networkErrorHelper, stringHelper, utilsService } from "libs";
import { Button, Icon } from "design-react-kit";
import { FormEnabler, ValidatedForm } from "components/forms";
import { ROUTES } from "const";
import { LessonActivityConfiguration } from "./LessonActivityConfiguration";

class LessonActivity extends ValidatedForm {
  state = {
    loading: true,
    loadingError: false,
    course: "",
    activity: "",
    activityRevision: "",
    myCourse: "",
    myTraining: "",
    formActive: false,
    activityDescription: "",
    numHours: "",
    document: 0,
    idQuestion: null,
    currentSchool: null,
    isSchoolVerified: false,
    checkSchool: false,
    defaultValues: {},
  };

  componentDidMount() {
    const { rCode, idLesson, activityType } = this.props.match.params;
    this.rCode = rCode;
    this.idLesson = idLesson;

    this.template = stringHelper.capitalizeFirstLetter(activityType);
    const config = LessonActivityConfiguration;

    this.FIELDS_GROUP = config.getFields(this.template, this);
    this.validation = config.getValidators(this.template);
    this.ERROR_MESSAGES = config.getErrorMessages(this.template);
    this.pageTitle = config.getPageTitle(this.template);

    const defaultValues = config.getDefaultValues(this.template);
    this.setState({
      ...defaultValues,
      defaultValues,
    });

    this.loadCourse(rCode, idLesson);
  }

  loadCourse(rCode, idLesson) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        this.setState({
          myCourse: data.payload.userCourse,
          course: data.payload.course,
        });

        this.loadTraining(idLesson, rCode);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({ loadingError: true, loading: false });
        }
      });
  }

  loadTraining(idLesson, rCode) {
    lessonTrainingService
      .myTraining(idLesson, rCode)
      .then(({ data }) => {
        this.setState({
          myTraining: data.payload.lessonTraining,
        });

        this.loadRemote(rCode, idLesson);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({ loadingError: true, loading: false });
        }
      });
  }

  getPayload(status) {
    const { myCourse, myTraining, activity } = this.state;
    const { lessonType, activityType } = this.props.match.params;

    //get type
    let type;

    switch (activityType) {
      case "Indire":
        type = "text";
        break;
      case "TirocinioDiretto":
        type = "file";
        break;
      case "TirocinioDirettoIndire":
        type = "file";
        break;
      default:
        type = "text";
        break;
    }

    const fieldsGroup = this.FIELDS_GROUP.flat();

    //search for question fields
    const questions = fieldsGroup
      .filter((field) => field.id && this.state[field.id] != null)
      .map((field) => ({
        field: field.field,
        question: field.label,
        answer: this.state[field.id]?.value,
        type,
      }));

    const payload = {
      userId: myCourse.userId,
      courseId: myCourse.courseId,
      lessonId: parseInt(this.idLesson),
      lessonType,
      status,
      registrationCode: this.rCode,
      activityType: activityType.toLowerCase(),
      durata: myTraining.durata,
      lessonActivityId: activity.id || "",
      questions,
    };

    return payload;
  }

  loadRemote(rCode, idLesson) {
    learningService
      .loadLessonActivity(rCode, idLesson)
      .then(({ data }) => {
        const activity = data.payload.activity;
        const questions = activity.questions;
        const activityRevision = data.payload.activityRevision;

        const { defaultValues } = this.state;

        const mainQuestion = questions.find((q) => q.field === "numHours");

        const newState = {
          activity,
          activityRevision,
          idQuestion: mainQuestion.id,
          formActive: activity.status === "draft" || activity.status === "revisionPending",
          loading: false,
        };

        questions.forEach((q) => {
          if (q.field) {
            defaultValues[q.field] = q.answer ?? "";

            newState[q.field] = q.answer ?? "";
          }
        });

        newState.defaultValues = {
          ...defaultValues,
          document: mainQuestion.id,
        };

        this.setState(newState);
      })

      .catch((error) => {
        if (networkErrorHelper.is404(error)) {
          this.createDraft();
        } else {
          networkErrorHelper.notify(error);
          this.setState({
            loadingError: true,
            loading: false,
          });
        }
      });
  }

  createDraft = async () => {
    const payload = this.getPayload("draft");

    learningService
      .insertLessonActivity(payload)
      .then(({ data }) => {
        const activity = data.payload.lessonActivity;
        const lessonActivityQuestions = data.payload.lessonActivityQuestions;

        const mainQuestion = lessonActivityQuestions.find((q) => q.field === "numHours");
        const idQuestion = mainQuestion.id;

        this.setState((prev) => ({
          activity,
          formActive: true,
          loading: false,
          idQuestion,
          defaultValues: { ...prev.defaultValues, document: idQuestion },
        }));
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  };

  saveRemote = () => {
    ModalHandler.show(
      null,
      "Conferma",
      "Dopo aver confermato, le informazioni fornite verranno salvate definitivamente e non sarà più possibile inviarle nuovamente. Vuoi procedere?",
      null,
      this.saveConfirmed,
    );
  };

  saveConfirmed = async () => {
    const { rCode, idLesson } = this;

    const payload = this.getPayload("confirmed");

    learningService
      .updateLessonActivity(payload)
      .then(() => {
        this.setState({ formActive: false });
        this.loadRemote(rCode, idLesson);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  };

  showForm = () => {
    this.setState({ formActive: false });
  };

  downloadPDF = () => {
    const { rCode, idLesson } = this;

    this.setState({ loading: true });

    learningService
      .downloadPdfLessonActivity(rCode, idLesson)
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        //create download link
        const link = document.createElement("a");
        link.href = url;
        link.download = `relazione_attivita_autoformazione_${rCode}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);

        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error);
        const requestError =
          "Si è verificato un errore durante l'elaborazione della richiesta. Contattare il supporto tecnico. Dettagli errore:" +
          networkErrorHelper.getErrorMessage(error);
        this.setState({ loading: false, loadingError: requestError });
      });
  };

  verifySchool = () => {
    const schoolCode = this.getValueField("schoolCode");

    if (!schoolCode || schoolCode.length !== 10) {
      this.setState({ checkSchool: true, isSchoolVerified: false, currentSchool: null, currentSchoolError: "Il codice scuola deve essere di 10 caratteri" });
      return;
    }

    utilsService
      .getSchoolByCode(schoolCode)
      .then(({ data }) => {
        const currentSchool = data.payload.result;

        console.log("currentSchool", currentSchool);
        this.setState({
          isSchoolVerified: true,
          checkSchool: true,
          currentSchool,
          currentSchoolError: "",
        });

        //trigger field validation
        this.onChange("schoolCode", schoolCode);
      })
      .catch((error) => {
        this.setState({
          isSchoolVerified: false,
          checkSchool: true,
          currentSchool: null,
          currentSchoolError: "Scuola non trovata. Verificare il codice inserito o contattare il supporto tecnico.",
        });

        //trigger field validation
        this.onChange("schoolCode", schoolCode);

        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(this.errors);
        }
      });
  };

  onSchoolCodeChange = (field, value) => {
    const currentSchoolCode = this.getValueField("schoolCode");

    if (value !== currentSchoolCode) {
      this.setState({
        isSchoolVerified: false,
        checkSchool: false,
        currentSchool: null,
        currentSchoolError: "",
      });
    }
  };

  renderInfoIndire() {
    const { activityDescription } = this.state;

    const cardProps = {
      className: "my-5",
      tag: "Relazione sull'attività di autoformazione",
      content: (
        <div>
          <p>{typeof activityDescription === "string" ? activityDescription : activityDescription?.value}</p>
        </div>
      ),
    };

    return (
      <>
        <p className="mt-5">La tua relazione inserita:</p>
        <MnemoCardTag {...cardProps} />
        <Button onClick={this.downloadPDF} color="primary bg-dark" className="mt-3 float-right">
          Scarica PDF
        </Button>
      </>
    );
  } // renderInfoIndire

  renderIndire() {
    return (
      <>
        <MSection className="my-3">
          <p>Dopo la realizzazione di un percorso di autoapprendimento che prevede un'attività sulle piattaforme:</p>
          <ul>
            <li>
              Biblioteca Innovazione Indire{" "}
              <a href="https://biblioteca.indire.it" target="_blank" rel="noopener noreferrer">
                https://biblioteca.indire.it
              </a>
            </li>
            <li>
              E-twinning (previa registrazione in 48 ore){" "}
              <a href="https://etwinning.indire.it/" target="_blank" rel="noopener noreferrer">
                https://etwinning.indire.it
              </a>
            </li>
          </ul>
          <p></p>
          <p>inserire nel box in seguito mostrato una breve relazione contenente:</p>
          <ul>
            <li>Breve descrizione della piattaforma utilizzata</li>
            <li>Breve approfondimento sulla tematica didattica scelta</li>
            <li>Conclusioni</li>
          </ul>
          <hr />

          <small>La relazione dovrà assestarsi su massimo 500 battute spazi inclusi.</small>
          {this.state.formActive ? this.renderForm() : this.renderInfoIndire()}
        </MSection>
      </>
    );
  } // renderIndire

  renderTirocinioDiretto() {
    //console.log("renderTirocinioDiretto", this.state.myCourse);
    return (
      <>
        {this.state.myCourse?.courseConfig && this.state.myCourse.courseConfig.disableATD ? (
          <BoxDanger className="m-5">
            Il caricamento dei documenti è stato disabilitato. Per ulteriori informazioni <SupportoTecnico />
          </BoxDanger>
        ) : (
          <MSection className="my-3">
            {this.state.formActive ? (
              <>
                <p>Carica le informazioni e i documenti richiesti:</p>
                <hr />
                {this.renderForm()}
              </>
            ) : (
              <>
                <p>Le informazioni e i documenti che sono stati caricati.</p>
                <hr />
                {this.renderForm()}
              </>
            )}
          </MSection>
        )}
      </>
    );
  } // renderTirocinioDiretto

  //---- end render methods for different templates ----

  renderForm() {
    const { defaultValues, formActive, activity, isSchoolVerified, currentSchool, checkSchool, currentSchoolError } = this.state;
console.log("renderForm", currentSchoolError);
    const { formValid, code } = this.renderFields(this.FIELDS_GROUP, defaultValues, formActive);

    const isTirocinioDiretto = this.template === "TirocinioDiretto";
    const schoolOk = isTirocinioDiretto ? checkSchool && isSchoolVerified : true;

    const enableSave = (formValid && schoolOk) || activity.status === "revisionPending";

    return (
      <>
        <form className="mt-3">
          {code}
          {isSchoolVerified && currentSchool && formActive && (
            <BoxSuccess>
              <strong>{currentSchool.name}</strong>
              <br />
              {currentSchool.address ? currentSchool.address : ""}, {currentSchool.city} {currentSchool.zipCode ? `(${currentSchool.zipCode})` : ""}
            </BoxSuccess>
          )}
          { currentSchoolError && formActive && (
            <BoxDanger>
              <strong>{currentSchoolError}</strong>
            </BoxDanger>
          )}

        </form>
        {formActive && <FormEnabler isFormActive={formActive} onSubmit={this.onSubmit} disableSave={!enableSave} hideCancel={true} />}
      </>
    );
  }

  render() {
    const { loading, activity, activityRevision } = this.state;

    if (loading) return <MnemoLoading />;

    return (
      <>
        <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${this.rCode}`} className="mx-5 btn btn-outline-primary float-right">
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>{this.pageTitle}</Title>
        {loading ? (
          <MnemoLoading />
        ) : (
          <>
            {activity?.status === "revisionPending" && activityRevision.revisionNote && (
              <MnemoCallout className="mnemo-callout-danger w-100">
                <h5 className="text-red">ATTENZIONE: Documentazione non idonea</h5>
                <i>{activityRevision.revisionNote}</i>
              </MnemoCallout>
            )}
            {/* TODO SAVERIO: sistemare meglio sta cosa: deve essere creato array cn i testi e un 
                solo metodo render */}
            {this.template === "Indire" ? this.renderIndire() : this.renderTirocinioDiretto()}
          </>
        )}
      </>
    );
  }
}

export default withRouter(LessonActivity);
